import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  TipoControl,
  TablaMaestra,
  ColumnaMaestra,
} from '@app/shared';

@Injectable()
export class MasterStructureDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService ) { }

  /**
   * retorna los tipos de controles(Campos) registrados en el sistema
   *
   * @returns {Observable<TipoControl[]>}
   * @memberof MasterStructureDataService
   */
  getTypesControl(): Observable<TipoControl[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<TipoControl[]>(this.api.get('typeField')).subscribe(
        field => {
          const formattedData: TipoControl[] = [];
          field.forEach((el: TipoControl) => {
            if (el.nombre !== 'label' && el.nombre !== 'coordenadas') {
              formattedData.push({
                nombre: el.nombre,
                descripcion: el.descripcion,
                id: el.id
              });
            }
          });
          obs.next(formattedData);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Guardar estructura de la maestra
   *
   * @param {number} idMaster
   * @param {ColumnaMaestra[]} createColums
   * @param {ColumnaMaestra[]} updateColums
   * @param {Array<number>} deleteColumns
   * @returns {Observable<boolean>}
   * @memberof MasterStructureDataService
   */
  savedStructure(
    idMaster: number,
    createColums: ColumnaMaestra[],
    updateColums: ColumnaMaestra[],
    deleteColumns: Array<number>
  ): Observable<boolean> {
    const form = {};

    if (createColums.length) {
      createColums.map(column => {
        column.tipo_campo = column.tipo_campo['id'];
        if (column.maestra_dependencia && typeof column.maestra_dependencia === 'object') {
          column.maestra_dependencia = column.maestra_dependencia['id'];
        }
      });

      form['crear'] = createColums;

    }
    if (updateColums.length) {
      updateColums.map(column => {
        column.tipo_campo = column.tipo_campo['id'];
        if (column.maestra_dependencia && typeof column.maestra_dependencia === 'object') {
          column.maestra_dependencia = column.maestra_dependencia['id'];
        }
      });
      form['actualizar'] = updateColums;
    }

    if (deleteColumns.length) {
      form['eliminar'] = deleteColumns;
    }

    return new Observable(obs => {
      this.http.skipErrorHandler().put(this.api.get('structureMasterTable', [idMaster]), form, {
        observe: 'response'
      }).subscribe(
        (res: any) => {
          this.toastr.success('Estructura de la tabla maestra guardada correctamente', 'Operación exitosa');
          obs.next(true);
        },
        (err: any) => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error.nombre) {
              this.toastr.error(err.error.nombre, 'Error de operacion');
            } else {
              this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operacion');
            }
          }
          obs.next(false);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/shared/master-structure-data.service.ts